import { prechargeTranslations } from "./precharge-pt-br";

export const precharge_ES_MX: prechargeTranslations = {
	title: "Operaciones de precarga",
	searchPlaceholder: "Buscar por nombre de operación de precarga",
	createNewPrecharge: "Crear operación de precarga",
	noSearchResults: "La búsqueda no encontró resultados",
	empty: "No hay operaciones de precarga registradas",
	card: {
		noTermsOfService: "Sin términos de servicio",
		noEnd: "Sin término",
	},
	addNewPrecharge: {
		prechargeOperation: "Operaciones de precarga",
		siteConfig: "Configuración del sitio",
		eventName: "Nombre del evento",
		termsOfService: "Términos de servicio",
		ticketUrl: "URL del ticket",
		slug: "Slug",
		aliases: "Alias",
		siteAppearance: "Apariencia del sitio",
		cover: "Portada",
		logo: "Logo",
		mainImage: "Imagen principal",
		primaryColor: "Color primario",
		darkMode: "Modo oscuro",
		operationConfig: "Configuración de la operación",
		beginAt: "Comienza en",
		endsAt: "Termina en",
		childFriendly: "Adecuado para niños",
		preSetedValues: "Valores pre-seleccionados",
		bonus: "Bonificación",
		minimumValue: "Valor mínimo",
		rechargeConfig: "Configuración de recarga",
		expirationDate: "Fecha de expiración de recargas",
		validRechargDate: "Las recargas son válidas desde",
		rechargeDuration: "Duración de recarga",
	},
	sideTab: {
		edit: "Editar operación de precarga",
		withoutTerms: "Sin términos de servicio",
		preChargeOperation: "Operación de precarga",
		slug: "SLUG",
		beginAt: "Comienza en",
		endsAt: "Termina en",
		expiresAt: "Fecha de expiración de recargas",
		undefined: "Indefinido",
		validRecharges: "Las recargas son válidas desde",
		darkMode: "Modo oscuro",
		childFriendly: "Adecuado para niños",
		primaryColor: "Color primario",
		durability: "Duración de recarga",
		remove: {
			title: "¿Está seguro de que desea eliminar esta operación de precarga?",
			button: "Eliminar operación de precarga",
		},
	},
	prechargeStore: {
		createPrechargeOperationSuccess: "Operación de precarga creada exitosamente",
		updatePrechargeOperationSuccess: "Operación de precarga actualizada exitosamente",
		deletePrechargeOperationSuccess: "Operación de precarga eliminada exitosamente",
	},
	report: {
		precharge: "Precarga",
		edit: "Editar sitio",
		showSite: "Ver sitio",
		costumersTitle: "{{value}} personas",
		costumersDescription: "Precargaron",
		ticketsDescription: "Boleto promedio",
		collectedDescription: "Cantidad cobrada",
		redeemedDescription: "Valor canjeado",
		maleTitle: "{{value}} hombres",
		femaleTitle: "{{value}} mujeres",
		otherTitle: "{{value}} otros",
		paymentMethod: "Método de pago",
		value: "Valor",
		prechargePerDay: "Precargas por día",
		date: "Fecha",
		dateHour: "Fecha/Hora",
		name: "Nombre",
		document: "Documento",
		email: "Email",
		bonus: "Bonificación",
		cardSymmary: "Tarjeta usada",
		cardBrand: "Bandera de tarjeta",
		isUsed: "¿Rescatado?",
		filter: {
			name: "Nombre del cliente",
			document: "Documento",
			email: "Email",
			acquirerTransactionId: "Transacción del adquirente",
			paymentMethod: "Método de pago",
			status: "Status",
		},
		creditCard: "Tarjeta de crédito",
		pix: "PIX",
		billing: "Facturación",
		total: "Total",
		rescuedValue: "Valor rescatado",
		residual: "Residual",
		status: {
			pendingReview: "Pendiente",
			refunded: "Reembolsado",
			refused: "Rechazado",
			success: "Aprobado",
		},
		errors: {
			hasWhitespace: "No puede contener espacios",
			hasUpperCase: "No puede contener letras mayúsculas",
			hasSpecialCharacter: "No puede contener caracteres especiales",
			acquirerTransactionIdError: "Ingrese una ID válida",
			documentError: "Ingrese un documento válido",
		},
	},
	homePage: {
		deleteTitle: "Eliminar sitio de precarga",
		deleteSubtitle: "¿Está seguro de que desea eliminar este sitio de precarga?",
		title: "Precarga",
		description:
			"Crear un sitio web para que los clientes puedan precargar antes del inicio del evento, evitando colas y consecuentemente reduciendo el volumen de operaciones en el evento.",
		createButton: "Crear sitio de precarga",
		searchInputPlaceholder: "Buscar un sitio",
		willExpire: "Expira en",
		hasExpired: "Expirado en",
		copyLink: "Copiar enlace al sitio web",
		active: "Activo",
		inactive: "Inactivo",
		expired: "Caducado",
		copied: "Enlace copiado.",
		report: "Informe",
	},
	formPage: {
		title: "Nuevo sitio web de Pre-Charge",
		description:
			"Rellene los datos y promocione el sitio web entre sus clientes. Permita a los usuarios realizar la carga previa antes de que comience el evento, evitando colas y reduciendo el volumen de operación en el evento.",
		nextStep: "Siguiente paso",
		discard: "Descartar creación",
		logoDescription: "La imagen debe estar en .jpeg o .png, con 880px por 880px",
		siteSettingsTitle: "Configuración del sitio",
		rechargeSettingsTitle: "Configuración de precarga",
		tipsTitle: "Consejos para eventos",
		eventData: {
			title: "Información del evento",
			logo: "Logotipo del evento",
			eventName: "Nombre del evento",
			eventNamePlaceholder: "Ingrese el nombre del evento",
			email: "Correo electrónico de contacto",
		},
		customization: {
			title: "Personalización del sitio web",
			slug: "URL del sitio",
			slugPlaceholder: "Ingrese el nombre del evento",
			color: "Color de detalle",
			rechargesPeriod: "Período de precarga",
			endsAt: "Fecha límite del sitio",
			buffer: "Foto destacada de la página",
			mainPageInfoTitle: "Título de la página",
			mainPageInfoTitleDescription:
				"Sugerencia: ¿Precarga? '{{name}}' lo tiene! Planifica con antelación y evita colas",
			mainPageInfoTitlePlaceholder:
				"Ingrese aquí el título que desea colocar en la página",
			mainPageInfoSubtitle: "Texto complementario al título",
			colorPlaceholder: "Seleccionar color",
			slugDescription:
				"Personalice el enlace a su sitio de precarga. No puede contener espacios, letras mayúsculas ni caracteres especiales (!@#$%ˆ&*(){}[]<>).",
		},
		rechargeSettings: {
			title: "Configuración de precarga",
			rechargesLimit: "Reglas de límite de precarga",
			rechargesLimitDescription:
				"Establecer el valor mínimo por precarga y el valor mínimo por cliente (suma de todas las precargas previstas durante el período de operación).",
			minimumValue: "Valor mínimo de precarga",
			maximumValuePerUser: "alor máximo de precarga por límite",
			suggestion: "Sugerencia de valor de recarga",
			suggestionDescription:
				"En el sitio web de precarga, el cliente puede seleccionar uno de los valores ya sugeridos o ingresar el valor que desee, respetando los límites mínimo y máximo establecidos anteriormente. Sugiera 4 valores para que se muestren en el sitio web. Si Si lo deseas, también puedes obsequiar a tus clientes para que ganen bonificaciones basadas en sugerencias de valor.",
			preSetedValue: "Valor sugerido",
			bonus: "bono gratis",
			bonusDescription:
				"Si lo deseas, también puedes dar regalos a tus clientes para ganar bonificaciones basadas en sugerencias de valor.",
			paymentMethods: "Métodos de pago",
			paymentMethodsDescription:
				"Elija los métodos de pago que desea aceptar. Al menos uno de ellos debe ser seleccionado.",
			bonusTable: {
				rechargeValue: "Valor de recarga",
				bonus: "Bonificación",
			},
			addValue: "Agregar valor sugerido al sitio web",
			suggestedValue: "Valores sugeridos agregados",
			removeValue: "haga clic en la X para eliminar",
			noBonus: "Sin bonificación",
			minimumValueDescription: "El valor mínimo que su cliente puede cargar es",
			maximumValueDescription:
				"La suma de todos los valores de Precarga no puede exceder",
			cardTitle: "Sugerencia de precarga",
			cardBonus: "Bono gratuito",
			addButton: "Agregar valor sugerido",
			drawerTitle: "Agregar sugerencia",
			drawerOkButton: "Guardar sugerencia",
			radioYes: "Sí. Quiero ofrecer bonos a mis clientes",
			radioNo: "No. No quiero ofrecer bonos a mis clientes",
			bonusExample:
				"Al cargar <span>{{preSetedValue}}</span> tu cliente recibirá un bono gratis <span>{{bonus}}</span>.",
		},
		tips: {
			title: "Consejos para el evento",
			selectTips: "Sección de consejos para sitios web",
			yesOpt: "Sí. Agregar sección de consejos al sitio web.",
			noOpt: "No. No agregue una sección de sugerencias en el sitio web.",
			mainQuestion:
				"¿Quieres agregar una sección que contenga consejos para que los clientes tengan la mejor experiencia posible en tu evento?",
			importantInfoQuestion:
				"Define a continuación información importante sobre tu evento, dándole un título y un texto que lo complemente.",
			tipTitle: "Título de la sugerencia",
			tipTitlePlaceholder: "Ej.: ¿Puedo llevar agua en mi mochila?",
			tipDescription: "Texto informativo del consejo",
			tipDescriptionPlaceholder: "Ej.: Puedes llevar agua en botellas transparentes",
			addMoreTip: "Agregar más consejos",
			deleteTip: "Eliminar sugerencia",
			addButton: "Agregar sugerencia",
			drawerOkButton: "Guardar sugerencia",
		},
		validations: {
			required: "Campo requerido",
			requiredOption: "Seleccione una opción",
			invalidSlugRules: "una o más reglas no se cumplieron",
			maxValuPerUserLowerThanMinValue:
				"El valor máximo por usuario debe ser mayor que el valor mínimo",
			presetedValueLowerThanMinValue:
				"El valor de precarga debe ser mayor que el valor mínimo",
			presetedValueHigherThanMaxValuePerUser:
				"El valor de la precarga debe ser inferior al valor máximo por usuario",
			presetedValueAlreadyExists: "El valor preestablecido ya existe",
			isTipsEnabled: "Por favor agregue una sugerencia",
			slug: "Slug no cumple con las reglas anteriores",
			rechargesLimitMinimumValue:
				"El valor mínimo por usuario debe ser menor que el valor máximo",
			presetedValuesLowerThanMinValue:
				"Hay valores sugeridos inferiores al valor mínimo de recarga",
			presetedValuesHigherThanMaxValue:
				"Hay valores sugeridos superiores al valor máximo de recarga",
			preSetedBonus: "El valor del bono no puede ser mayor que el valor de la recarga",
		},
	},
};
